import { dynamicFailed } from "../hooks/useToast";
import { ICooperative } from "../exports/interfaces";
import axiosClient from "../axioxClient.ts/axiosClient";

export const fetchCooperative = async (): Promise<ICooperative[]> => {
  try {
    const response = await axiosClient.get<ICooperative[]>("/registers");
    return response.data;
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
    return [];
  }
};
